<template>
  <CDropdownToggle
    class="header-actions-icon header-focus-ring-trigger p-0 border-0 d-inline-flex align-items-center justify-content-center"
    aria-label="Notifications"
    aria-haspopup="menu"
    :aria-expanded="expanded ? 'true' : 'false'"
    :aria-controls="controlsId || undefined"
  >
    <div
      class="notification-icon d-flex align-items-center justify-content-center p-0"
    >
      <span class="notification-bell-icon" aria-hidden="true" />
      <div v-if="notSeen.length" class="notification-badge bg-accent-blue-dark">
        {{ notSeen.length > 9 ? "9+" : notSeen.length }}
      </div>
    </div>
  </CDropdownToggle>
</template>

<script>
import { useStore } from "vuex"
import { computed } from "vue"

export default {
  name: "NotificationsToggle",
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    /** `id` of the dropdown menu this toggle controls (`NotificationsList`). */
    controlsId: {
      type: String,
      default: ""
    }
  },
  setup() {
    const store = useStore()

    const notifications = computed(() => store.getters["sockets/notifications"])

    const notSeen = computed(() => {
      return notifications.value.filter((e) => !e.seen_at)
    })

    return {
      notSeen
    }
  }
}
</script>
